module.exports = __webpack_public_path__ + "img/2.0bd686e7.png";